import { HTTP } from "@/api/http-common";
import { HTTP_BLOB } from "../http-common";

export function callApiImportData(payload) {
  let payloadImport = payload.data;
  return new Promise((resolve, reject) => {
    return HTTP.post(`${payload.endPoint}`, payloadImport)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiDownloadTemplate(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_BLOB.get(`import/template?type=${payload}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiExportData(payload) {
  let searchRequest = payload.searchRequest;
  return new Promise((resolve, reject) => {
    return HTTP_BLOB.post(`${payload.endPoint}`, searchRequest)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
